import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import './LandingPage.css';
import { useNavigate } from "react-router-dom";
import { auth, db } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import logo from './assets/logo.png'; // 🔴 Import your logo
import event1 from './assets/event_pic1.jpg'
import event2 from './assets/event_pic2.jpg'
import event3 from './assets/event_pic3.jpg'
import event4 from './assets/event_pic4.jpg'
import event5 from './assets/event_pic5.jpg'
import event6 from './assets/event_pic6.jpg'
import event7 from './assets/event_pic7.jpg'
import event8 from './assets/event_pic8.jpg'
import carousel1 from './assets/carousel_1.jpg'
import carousel2 from './assets/carousel_2.jpg'
import carousel3 from './assets/carousel_3.jpg'
import carousel4 from './assets/carousel_4.jpg'
import carousel5 from './assets/carousel_5.jpg'
import carousel6 from './assets/carousel_6.jpg'
import bnb1 from './assets/bnb1.jpg'
import bnb2 from './assets/bnb2.jpg'
import bnb3 from './assets/bnb3.jpg'
import bnb4 from './assets/bnb4.jpg'
import bnb5 from './assets/bnb5.jpg'
import bnb6 from './assets/bnb6.jpg'  
import landing1 from './assets/landing1.jpg'
import landing2 from './assets/landing2.jpg'
import landing3 from './assets/landing3.jpg'
import landing4 from './assets/landing4.jpg'
import landing5 from './assets/landing5.jpg'
import landing6 from './assets/landing6.jpg'
import landing7 from './assets/landing7.jpg'
import landing8 from './assets/landing8.jpg'
import landing9 from './assets/landing9.jpg'
import landing12 from './assets/landing12.jpg'
import landing21 from './assets/landing21.jpg'
import LitStudio_Logo from './assets/LitStudio_Logo.png'; 
import Modal from './modal'; 
// Local Storage Helper
const LocalStorageHelper = {
  saveLoginData: (userId, email, name, userType = 'user') => {
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('userId', userId);
    localStorage.setItem('userEmail', email);
    localStorage.setItem('userName', name);
    localStorage.setItem('userType', userType);
  },

  isLoggedIn: () => {
    return localStorage.getItem('isLoggedIn') === 'true';
  },

  getLoginData: () => {
    return {
      userId: localStorage.getItem('userId'),
      email: localStorage.getItem('userEmail'),
      name: localStorage.getItem('userName'),
      userType: localStorage.getItem('userType'),
    };
  },

  clearLoginData: () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    localStorage.removeItem('userType');
  }
};

// Horizontal Image Marquee Component
const LandingHorizontalImageMarquee = () => {
  const images = useMemo(() => ([
    landing5, event2, landing7, event4, landing8, event6, landing3, event8,
    landing6, bnb2, landing4, landing9, bnb5, bnb6
  ]), []);

  return (
    <section className="landing-enhanced-marquee-section">
      <div className="landing-marquee-header">
        <h2 className="landing-enhanced-section-title">
          <span className="landing-title-main">Featured</span>
          <span className="landing-title-accent">Photography</span>
        </h2>
        <p className="landing-marquee-subtitle">
          Real work from photographers on LitStudio — every portfolio verified before it goes live.
        </p>
      </div>
      <div className="landing-enhanced-marquee-container">
        <div className="landing-enhanced-marquee-track">
          {images.map((img, index) => (
            <div key={`first-${index}`} className="landing-enhanced-marquee-item">
              <div className="landing-image-wrapper">
                <img
                  src={img}
                  alt={`Featured work ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          ))}
          {images.map((img, index) => (
            <div key={`second-${index}`} className="landing-enhanced-marquee-item">
              <div className="landing-image-wrapper">
                <img
                  src={img}
                  alt={`Featured work ${index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Main LandingPage Component
const LandingPage = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [logged_in, setLogged_in] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showCookie, setShowCookie] = useState(false);

  // Carousel refs and logic
  const carouselRef = useRef(null);
  const listRef = useRef(null);
  const runningTimeBarRef = useRef(null);
  const arrowsRef = useRef(null);
  const transitionTimeoutRef = useRef(null);
  const autoNextTimeoutRef = useRef(null);
  const profileWidgetRef = useRef(null);

  const TIME_RUNNING = 1500;
  const TIME_AUTO_NEXT = 3500;

  const categories = useMemo(() => ([
    {
      image: carousel1,
      title: "EVENT PHOTOGRAPHY",
      name: "Events",
      description: "Make your events unforgettable with LitStudio's expert event photography services!"
    },
    {
      image: carousel2,
      title: "WEDDING PHOTOGRAPHY",
      name: "Weddings",
      description: "Capture the magic of your special day with our professional wedding photographers."
    },
    {
      image: carousel3,
      title: "PORTRAIT PHOTOGRAPHY",
      name: "Portraits",
      description: "Professional portraits that capture personality and create lasting impressions."
    },
    {
      image: carousel6,
      title: "FASHION PHOTOGRAPHY",
      name: "Fashion",
      description: "High-end fashion photography for models, brands, and creative projects."
    },
    {
      image: carousel4,
      title: "PRODUCT PHOTOGRAPHY",
      name: "Products",
      description: "Professional product photography that showcases your items in the best light."
    },
    {
      image: carousel5,
      title: "FOOD PHOTOGRAPHY",
      name: "Food",
      description: "Bringing flavor to life — one delicious frame at a time."
    }
  ]), []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Sticky navbar state (presentational only)
  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Scroll reveal — progressive enhancement.
  // Sections render visible by default; we only opt into the animation once
  // we know the observer is available, so a failure here can never leave
  // content hidden.
  useEffect(() => {
    const root = document.querySelector('.landing-page');
    const targets = Array.from(document.querySelectorAll('.landing-reveal'));
    if (!root || targets.length === 0) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || typeof IntersectionObserver === 'undefined') return;

    root.classList.add('js-reveal-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach((el) => observer.observe(el));

    // Last-resort safety net: never leave a section hidden.
    const failSafe = setTimeout(() => {
      targets.forEach((el) => el.classList.add('is-visible'));
    }, 3000);

    return () => {
      clearTimeout(failSafe);
      observer.disconnect();
      root.classList.remove('js-reveal-ready');
    };
  }, []);

  // Firebase Authentication Check (keeping your existing code)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setAuthLoading(true);
      
      if (user) {
        try {
          const loginData = LocalStorageHelper.getLoginData();
          let userType = loginData.userType || 'user';
          
          let userDocRef = doc(db, userType === 'vendor' || userType === 'photographer' ? 'photographers' : 'users', user.uid);
          let userDoc = await getDoc(userDocRef);
          
          if (!userDoc.exists()) {
            userType = userType === 'vendor' || userType === 'photographer' ? 'user' : 'photographer';
            userDocRef = doc(db, userType === 'photographer' ? 'photographers' : 'users', user.uid);
            userDoc = await getDoc(userDocRef);
            
            if (userDoc.exists()) {
              LocalStorageHelper.saveLoginData(
                user.uid,
                user.email,
                user.displayName || "User",
                userType
              );
            }
          }
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            
            const getAvatarUrl = (userData, user) => {
              const avatarSources = [
                userData.profileImage,
                userData.avatarUrl,
                userData.avatar,
                user.photoURL
              ];
              
              const validAvatar = avatarSources.find(url => url && url.trim() !== '' && url !== 'undefined');
              
              if (validAvatar) {
                return validAvatar;
              }
              
              const name = userData.name || user.displayName || "User";
              return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
            };
            
            const profileData = {
              id: user.uid,
              name: userData.name || user.displayName || "User",
              email: userData.email || user.email,
              avatar: getAvatarUrl(userData, user),
              role: userType,
              joinDate: userData.createdAt,
              isVerified: user.emailVerified || userData.emailVerified || false,
              userType: userType
            };

            setUserProfile(profileData);
            setLogged_in(true);
            
            LocalStorageHelper.saveLoginData(
              user.uid,
              userData.email || user.email,
              userData.name || user.displayName || "User",
              userType
            );
            
          } else {
            const basicProfile = {
              id: user.uid,
              name: user.displayName || "User",
              email: user.email,
              userType: 'user',
              avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName || 'User')}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`,
              isVerified: user.emailVerified || false
            };
            
            setUserProfile(basicProfile);
            setLogged_in(true);
            
            LocalStorageHelper.saveLoginData(
              user.uid,
              user.email,
              user.displayName || "User",
              'user'
            );
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
          const basicProfile = {
            id: user.uid,
            name: user.displayName || "User",
            email: user.email,
            userType: 'user',
            avatar: `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName || 'User')}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`,
            isVerified: user.emailVerified || false
          };
          
          setUserProfile(basicProfile);
          setLogged_in(true);
        }
      } else {
        setLogged_in(false);
        setUserProfile(null);
        LocalStorageHelper.clearLoginData();
      }
      
      setAuthLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // Enhanced Logout Handler
  const handleLogout = useCallback(async () => {
    try {
      await signOut(auth);
      LocalStorageHelper.clearLoginData();
      
      setLogged_in(false);
      setUserProfile(null);
      setShowProfileMenu(false);
    } catch (error) {
      console.error('Error logging out:', error);
    }
  }, []);

  // Profile Menu Handlers
  const toggleProfileMenu = () => {
    setShowProfileMenu(prev => !prev);
  };

  const handleProfileClick = () => {
    setShowProfileMenu(false);
    
    if (userProfile?.userType === 'vendor' || userProfile?.userType === 'photographer') {
      navigate('/Upload');
    } else {
      navigate('/ProfileSettings');
    }
  };

  const handleSettingsClick = () => {
    setShowProfileMenu(false);
    navigate('/ProfileSettings');
  };

  const handleMyBookingsClick = () => {
    setShowProfileMenu(false);
    // '/UserBookings' has no route defined in App.js and rendered a blank page.
    // '/SentRequests' is the user's booking/enquiry history.
    navigate('/SentRequests');
  };

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileWidgetRef.current && !profileWidgetRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    if (showProfileMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showProfileMenu]);

  // Carousel Logic (keeping your existing code)
  const resetAnimation = useCallback(() => {
    if (runningTimeBarRef.current) {
      runningTimeBarRef.current.style.animation = "none";
      runningTimeBarRef.current.style.animation = `landing-runningTime ${TIME_AUTO_NEXT / 1000}s linear forwards`;
    }
  }, [TIME_AUTO_NEXT]);

  const updateProgressBar = useCallback(() => {
    const totalSlides = categories.length;
    const sliderItems = Array.from(listRef.current?.querySelectorAll(".landing-carousel-item") || []);
    if (sliderItems.length > 0) {
      const activeItem = parseInt(sliderItems[0].querySelector(".landing-carousel-title").getAttribute("data-item")) + 1;
      const progressPercentage = (activeItem / totalSlides) * 100;
      const progressBar = document.querySelector(".landing-progress-bar");
      if (progressBar) {
        progressBar.style.width = `${progressPercentage}%`;
      }
    }
  }, [categories.length]);

  const resetCarouselState = useCallback(() => {
    clearTimeout(transitionTimeoutRef.current);
    clearTimeout(autoNextTimeoutRef.current);

    transitionTimeoutRef.current = setTimeout(() => {
      if (carouselRef.current) {
        carouselRef.current.classList.remove("landing-next");
        carouselRef.current.classList.remove("landing-prev");
      }
    }, TIME_RUNNING);

    autoNextTimeoutRef.current = setTimeout(() => {
      handleSliderNavigation("next");
    }, TIME_AUTO_NEXT);

    resetAnimation();
  }, [TIME_RUNNING, TIME_AUTO_NEXT, resetAnimation]);

  const afterSlideChange = useCallback(() => {
    const slideNumberElement = document.querySelector(".landing-slide-number");
    if (slideNumberElement) slideNumberElement.remove();

    const sliderItems = Array.from(listRef.current?.querySelectorAll(".landing-carousel-item") || []);
    if (sliderItems.length > 0) {
      const activeItem = parseInt(sliderItems[1]?.querySelector(".landing-carousel-title")?.getAttribute("data-item") || "1");
      const activeIndex = activeItem < 10 ? `0${activeItem}` : activeItem.toString();

      const div = document.createElement("div");
      div.classList.add("landing-slide-number");
      div.textContent = `${activeIndex}/${sliderItems.length}`;

      if (arrowsRef.current) {
        arrowsRef.current.appendChild(div);
      }
    }

    updateProgressBar();
    resetCarouselState();
  }, [updateProgressBar, resetCarouselState]);

  const handleSliderNavigation = useCallback((direction) => {
    const sliderItems = listRef.current?.querySelectorAll(".landing-carousel-item");
    if (sliderItems && sliderItems.length > 0) {
      if (direction === "next") {
        listRef.current.appendChild(sliderItems[0]);
        if (carouselRef.current) {
          carouselRef.current.classList.add("landing-next");
        }
      } else if (direction === "prev") {
        listRef.current.prepend(sliderItems[sliderItems.length - 1]);
        if (carouselRef.current) {
          carouselRef.current.classList.add("landing-prev");
        }
      }
      afterSlideChange();
    }
  }, [afterSlideChange]);

  useEffect(() => {
    // Guard against a duplicate bar: this effect runs twice under
    // React.StrictMode in development, which previously appended two.
    if (
      arrowsRef.current &&
      !arrowsRef.current.querySelector(".landing-progress-bar-container")
    ) {
      const progressBarContainer = document.createElement("div");
      progressBarContainer.className = "landing-progress-bar-container";
      const progressBar = document.createElement("div");
      progressBar.className = "landing-progress-bar";
      progressBarContainer.appendChild(progressBar);
      arrowsRef.current.appendChild(progressBarContainer);
    }
    autoNextTimeoutRef.current = setTimeout(() => {
      handleSliderNavigation("next");
    }, TIME_AUTO_NEXT);

    resetAnimation();
    afterSlideChange();

    return () => {
      clearTimeout(transitionTimeoutRef.current);
      clearTimeout(autoNextTimeoutRef.current);
    };
  }, [TIME_AUTO_NEXT, handleSliderNavigation, resetAnimation, afterSlideChange]);

  // Newsletter subscription
  const handleSubscribe = (e) => {
    e.preventDefault();
    setEmail('');
  };

  // Navbar auth button
  const renderNavbarAuthButton = () => {
    if (authLoading) {
      return (
        <div className="landing-auth-loading">
          <div className="landing-loading-spinner"></div>
        </div>
      );
    }

    if (!logged_in) {
      return (
        <button type="button" className="landing-login-btn" onClick={() => navigate("/login")}>
          Log In
        </button>
      );
    }

    return <div></div>;
  };

  // Profile Widget (keeping your existing code)
  const renderProfileWidget = () => {
    if (!logged_in || !userProfile || authLoading) {
      return null;
    }

    const isPhotographer = userProfile.userType === 'vendor' || userProfile.userType === 'photographer';

    return (
      <div className="floating-profile-widget" ref={profileWidgetRef}>
        <div className="profile-widget-trigger" onClick={toggleProfileMenu}>
          <img 
            src={userProfile.avatar} 
            alt={userProfile.name} 
            className="profile-widget-avatar"
            onError={(e) => {
              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name)}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
            }}
          />
          <div className="profile-widget-info">
            <span className="profile-widget-name">{userProfile.name}</span>
            <span className="profile-widget-role">
              {isPhotographer ? 'Photographer' : 'User'}
            </span>
          </div>
          <div className="profile-widget-chevron">
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
              style={{ transform: showProfileMenu ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
            >
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </div>
        </div>

        {showProfileMenu && (
          <div className="profile-widget-menu">
            <div className="profile-widget-menu-header">
              <img 
                src={userProfile.avatar} 
                alt={userProfile.name} 
                className="profile-widget-menu-avatar"
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name)}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
                }}
              />
              <div className="profile-widget-menu-info">
                <h4>{userProfile.name}</h4>
                <p>{userProfile.email}</p>
                <span className="profile-widget-menu-badge">
                  {isPhotographer ? 'Photographer' : 'User'}
                </span>
              </div>
            </div>
            
            <div className="profile-widget-menu-divider"></div>
            
            <div 
              className="profile-widget-menu-item profile-widget-menu-item-primary"
              onClick={handleProfileClick}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {isPhotographer ? (
                  <>
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  </>
                ) : (
                  <>
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </>
                )}
              </svg>
              <span>{isPhotographer ? ' Dashboard' : ' Profile'}</span>
            </div>
            
            {!isPhotographer && (
              <>
                {/* <div 
                  className="profile-widget-menu-item"
                  onClick={handleMyBookingsClick}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                    <line x1="16" y1="2" x2="16" y2="6"></line>
                    <line x1="8" y1="2" x2="8" y2="6"></line>
                    <line x1="3" y1="10" x2="21" y2="10"></line>
                  </svg>
                  <span> My Bookings</span>
                </div> */}

                {/* <div 
                  className="profile-widget-menu-item"
                  onClick={handleSettingsClick}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="3"></circle>
                    <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1"></path>
                  </svg>
                  <span> Settings</span>
                </div> */}
              </>
            )}
            
            <div className="profile-widget-menu-divider"></div>
            
            <div 
              className="profile-widget-menu-item profile-widget-menu-item-logout"
              onClick={handleLogout}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16,17 21,12 16,7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
              <span> Log Out</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  // Mobile auth button
  const renderMobileAuthButton = () => {
    if (authLoading) {
      return (
        <div className="landing-mobile-auth-loading">
          <div className="landing-loading-spinner"></div>
        </div>
      );
    }

    if (!logged_in) {
      return (
        <button type="button" className="landing-mobile-login-btn" onClick={() => navigate("/login")}>
          Log In
        </button>
      );
    }

    const isPhotographer = userProfile.userType === 'vendor' || userProfile.userType === 'photographer';

    return (
      <div className="landing-mobile-profile">
        <div className="landing-mobile-profile-info">
          <img 
            src={userProfile.avatar} 
            alt={userProfile.name} 
            className="landing-mobile-profile-avatar"
            onError={(e) => {
              e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(userProfile.name)}&background=6366f1&color=fff&size=128&bold=true&font-size=0.6`;
            }}
          />
          <div className="landing-mobile-profile-details">
            <p className="landing-mobile-profile-name">
              {userProfile.name}
              {userProfile.isVerified && (
                <svg className="landing-verified-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20,6 9,17 4,12"></polyline>
                </svg>
              )}
            </p>
            <p className="landing-mobile-profile-email">{userProfile.email}</p>
            {userProfile.role && (
              <span className="landing-mobile-profile-role">{isPhotographer ? 'Photographer' : 'User'}</span>
            )}
          </div>
        </div>
        
        <div className="landing-mobile-profile-actions">
          <div className="landing-mobile-profile-clickable" onClick={handleProfileClick}>
            {isPhotographer ? ' My Dashboard' : ' My Profile Settings'}
          </div>
          
          {!isPhotographer && (
            <>
              <div className="landing-mobile-profile-clickable" onClick={handleMyBookingsClick}>
                 My Bookings
              </div>
              
              <div className="landing-mobile-profile-clickable" onClick={handleSettingsClick}>
                 Settings
              </div>
            </>
          )}
          
          <div className="landing-mobile-profile-clickable landing-mobile-logout" onClick={handleLogout}>
             Log Out
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="landing-page">
      {/* Floating Profile Widget */}
      {renderProfileWidget()}

      {/* Single sticky top bar (replaces the previous duplicate navbars) */}
      <header className={`landing-topbar ${isScrolled ? 'is-stuck' : ''}`}>
        <div className="landing-top-left-logo" onClick={() => navigate("/")}>
          <img src={LitStudio_Logo} alt="LitStudio" className="landing-top-logo-image" />
        </div>

        <nav className="landing-navbar">
          <div className="landing-nav-container">
            <div className="landing-nav-pill">
              <div className="landing-nav-links-container">
                <button type="button" className="landing-nav-link" onClick={() => navigate("/BrowsePhotographer")}>
                  Browse Photographers
                </button>
                <button type="button" className="landing-nav-link" onClick={() => navigate("/Login")}>
                  Join as Photographer
                </button>
                <button type="button" className="landing-nav-link" onClick={() => navigate("/AboutUs")}>
                  About Us
                </button>
              </div>
            </div>
          </div>
        </nav>

        <div className="landing-nav-actions">
          {renderNavbarAuthButton()}
          <div
            className={`landing-hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            onKeyDown={(e) => e.key === 'Enter' && toggleMenu()}
            role="button"
            tabIndex={0}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </header>

      <div className={`landing-mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <button type="button" className="landing-mobile-nav-link" onClick={() => navigate("/BrowsePhotographer")}>
          Browse Photographers
        </button>
        <button type="button" className="landing-mobile-nav-link" onClick={() => navigate("/Login")}>
          Join as Photographer
        </button>
        <button type="button" className="landing-mobile-nav-link" onClick={() => navigate("/AboutUs")}>
          About Us
        </button>
        {renderMobileAuthButton()}
      </div>

      {/* Hero Section */}
      <section className="landing-hero-section-bg">
        <div className="landing-hero-content-bg">
          <div className="landing-hero-text-bg">
            <div className="landing-caption-tag">Discover. Book. Smile – Photography Simplified</div>
            <h1 className="landing-hero-title-bg">
              Your story,<br />
              <span className="landing-hero-title-muted">perfectly captured.</span>
            </h1>
            <p className="landing-hero-description-bg">
              Connect with skilled photographers who'll bring your vision to life. Book now for unforgettable moments.
            </p>

            <div className="landing-hero-actions">
              <button type="button" className="landing-cta-button" onClick={() => navigate("/EnquiryForm")}>
                Book Now
              </button>
              <button
                type="button"
                className="landing-cta-secondary"
                onClick={() => navigate("/BrowsePhotographer")}
              >
                Browse Photographers
              </button>
            </div>

            <div className="landing-hero-trust">
              <div className="landing-trust-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <path d="M12 2 4 5v6c0 5 3.4 9.4 8 11 4.6-1.6 8-6 8-11V5l-8-3Z" />
                  <polyline points="9 12 11 14 15 10" />
                </svg>
                <span>Verified photographers</span>
              </div>
              <div className="landing-trust-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <rect x="2" y="5" width="20" height="14" rx="2" />
                  <line x1="2" y1="10" x2="22" y2="10" />
                </svg>
                <span>Secure payments</span>
              </div>
              <div className="landing-trust-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
                <span>Book in minutes</span>
              </div>
            </div>
          </div>

          <div className="landing-hero-media" aria-hidden="true">
            <div className="landing-hero-media-col">
              <img src={landing1} alt="" decoding="async" />
              <img src={landing8} alt="" loading="lazy" decoding="async" />
            </div>
            <div className="landing-hero-media-col">
              <img src={landing2} alt="" decoding="async" />
              <img src={event7} alt="" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section with 3D Carousel */}
      <section className="landing-categories">
        <div className="landing-categories-header landing-reveal">
          <span className="landing-eyebrow">What we shoot</span>
          <h2 className="landing-section-title">Popular Categories</h2>
          <p className="landing-lede">
            From weddings to product shoots — find a specialist for the exact story you need told.
          </p>
        </div>
        <div className="landing-carousel-container-wrapper">
          <div className="landing-carousel" ref={carouselRef}>
            <div className="landing-list" ref={listRef}>
              {categories.map((category, index) => (
                <div 
                  key={index} 
                  className="landing-carousel-item" 
                  style={{ backgroundImage: `url(${category.image})` }}
                >
                  <div className="landing-carousel-content">
                    <div className="landing-carousel-title" data-item={index + 1}>{category.title}</div>
                    <div className="landing-carousel-name">{category.name}</div>
                    <div className="landing-carousel-des">{category.description}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="landing-arrows" ref={arrowsRef}>
              <button type="button" className="landing-prev" onClick={() => handleSliderNavigation("prev")}>
                <span>‹</span>
              </button>
              <button type="button" className="landing-next" onClick={() => handleSliderNavigation("next")}>
                <span>›</span>
              </button>
            </div>
            <div className="landing-timeRunning" ref={runningTimeBarRef}></div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="landing-steps-section">
        <div className="landing-steps-inner">
          <div className="landing-steps-header landing-reveal">
            <span className="landing-eyebrow">How it works</span>
            <h2 className="landing-section-title">Booked in three steps</h2>
            <p className="landing-lede">
              No back-and-forth, no guesswork. Tell us what you need and we handle the rest.
            </p>
          </div>

          <div className="landing-steps-grid">
            <div className="landing-step-card landing-reveal">
              <div className="landing-step-num">01</div>
              <h3>Tell us your brief</h3>
              <p>Share your event type, date and location. It takes about a minute.</p>
            </div>
            <div className="landing-step-card landing-reveal">
              <div className="landing-step-num">02</div>
              <h3>Match with a photographer</h3>
              <p>Compare verified portfolios and pricing, then pick the style that fits you.</p>
            </div>
            <div className="landing-step-card landing-reveal">
              <div className="landing-step-num">03</div>
              <h3>Shoot and receive</h3>
              <p>Your payment is held securely until the shoot is done and delivered.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Help Section */}
      <section className="landing-help-section">
        <div className="landing-section-header landing-reveal">
          <div className="landing-line"></div>
          <span className="landing-eyebrow">Two ways in</span>
          <h2 className="landing-section-title">See how <strong>LitStudio</strong> can help you</h2>
        </div>
        <div className="landing-services-container landing-reveal">
          <div className="landing-service-cards">
            <div className="landing-service-card">
              <img src={landing12} alt="Book a Photoshoot" loading="lazy" decoding="async" />
              <span className="landing-service-tag">For clients</span>
              <h4>Book a Photoshoot</h4>
              <p>Find the perfect photographer for your special moments and create memories that last a lifetime.</p>
              <ul className="landing-service-features">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Compare verified portfolios side by side</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>See pricing upfront before you commit</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Payment held securely until delivery</span>
                </li>
              </ul>
              <button type="button" className="landing-service-btn" onClick={() => navigate("/BrowsePhotographer")}>
                Find a photographer
              </button>
            </div>
            <div className="landing-service-card" onClick={() => navigate("/Login")}>
              <img src={landing21} alt="Join as Photographer" loading="lazy" decoding="async" />
              <span className="landing-service-tag">For photographers</span>
              <h4>Join as Photographer</h4>
              <p>Showcase your portfolio, connect with clients, and grow your photography business with us.</p>
              <ul className="landing-service-features">
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Set your own packages and pricing</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Manage bookings and schedules in one place</span>
                </li>
                <li>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
                  <span>Secure payouts on every completed shoot</span>
                </li>
              </ul>
              <button type="button" className="landing-service-btn">Start earning</button>
            </div>
          </div>
        </div>
      </section>

      {/* Horizontal Image Marquee */}
      <LandingHorizontalImageMarquee />

      {/* Conversion band */}
      <section className="landing-cta-band">
        <div className="landing-cta-band-inner landing-reveal">
          <h2>
            Ready to make it <span className="landing-italic">Lit?</span>
          </h2>
          <p>
            Tell us about your shoot and we'll match you with photographers who fit your style, date and budget.
          </p>
          <button type="button" className="landing-cta-button" onClick={() => navigate("/EnquiryForm")}>
            Book Now
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
  <div className="landing-footer-content">
    <div className="landing-footer-text">
      <p>Whether it's your big day, a milestone, or just because - we bring the moment, we'll make it Lit!</p>
    </div>
    <div className="landing-subscription">
      <p>Subscribe and be first to get offers</p>
      <form className="landing-subscription-form" onSubmit={handleSubscribe}>
        <input 
          type="email" 
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" className="landing-subscribe-btn">Subscribe!</button>
      </form>
    </div>
  </div>
  
  <div className="landing-social-links">
    <button type="button" className="landing-social-link" onClick={() => window.open('https://facebook.com', '_blank')}>
      <span>f</span>
    </button>
    <button type="button" className="landing-social-link" onClick={() => window.open('https://www.linkedin.com/company/thelitstudio/', '_blank')}>
      <span>in</span>
    </button>
    <button type="button" className="landing-social-link" onClick={() => window.open('https://www.instagram.com/litstudio.in/', '_blank')}>
      <span>ig</span>
    </button>
  </div>
  
  <div className="landing-footer-bottom">
    <p>&copy; 2025 LitStudio. All rights reserved.</p>
    <div className="landing-footer-links">
     <button type="button" onClick={() => setShowPrivacy(true)}>Privacy</button>

      <button type="button" onClick={() => setShowCookie(true)}>Cookie Settings</button>
      <button type="button" onClick={() => setShowTerms(true)}>Terms & Conditions</button>
    </div>
  </div>

  {/* Privacy Policy Modal */}
  <Modal 
    isOpen={showPrivacy} 
    onClose={() => setShowPrivacy(false)}
    title="Privacy Policy"
  >
    <p><strong>Effective Date:</strong> November 22, 2025</p>
    <p><strong>Last Updated:</strong> November 22, 2025</p>

    <h3>1. Introduction</h3>
    <p>
      Welcome to LitStudio ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our photography marketplace services.
    </p>

    <h3>2. Information We Collect</h3>
    
    <h4>2.1 Personal Information</h4>
    <p>We collect personal information that you voluntarily provide to us when you:</p>
    <ul>
      <li>Register on the platform as a user or photographer</li>
      <li>Make a booking or enquiry</li>
      <li>Subscribe to our newsletter</li>
      <li>Contact us for support</li>
    </ul>
    <p>This information may include:</p>
    <ul>
      <li>Full name and contact details (email address, phone number)</li>
      <li>Event details (type, date, location, requirements)</li>
      <li>Payment information (processed securely through third-party providers)</li>
      <li>Profile information and photographs (for photographers)</li>
      <li>User preferences and booking history</li>
    </ul>

    <h4>2.2 Automatically Collected Information</h4>
    <p>When you visit our website, we automatically collect certain information about your device, including:</p>
    <ul>
      <li>IP address and browser type</li>
      <li>Operating system and device information</li>
      <li>Usage data and browsing patterns</li>
      <li>Cookies and similar tracking technologies</li>
    </ul>

    <h3>3. How We Use Your Information</h3>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Provide, operate, and maintain our photography marketplace services</li>
      <li>Process bookings and facilitate connections between clients and photographers</li>
      <li>Send you booking confirmations, updates, and customer support communications</li>
      <li>Improve our website and personalize your experience</li>
      <li>Send promotional emails and newsletters (with your consent)</li>
      <li>Detect, prevent, and address technical issues or fraudulent activity</li>
      <li>Comply with legal obligations and enforce our Terms & Conditions</li>
    </ul>

    <h3>4. Information Sharing and Disclosure</h3>
    <p>We do not sell your personal information. We may share your information with:</p>
    <ul>
      <li><strong>Photographers:</strong> When you make a booking, we share necessary details with the photographer</li>
      <li><strong>Service Providers:</strong> Third-party vendors who assist us (payment processors, email services, analytics)</li>
      <li><strong>Legal Compliance:</strong> When required by law or to protect our rights</li>
      <li><strong>Business Transfers:</strong> In connection with any merger, sale, or acquisition</li>
    </ul>

    <h3>5. Data Security</h3>
    <p>
      We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
    </p>

    <h3>6. Your Rights and Choices</h3>
    <p>You have the right to:</p>
    <ul>
      <li>Access, update, or delete your personal information</li>
      <li>Opt-out of marketing communications</li>
      <li>Disable cookies through your browser settings</li>
      <li>Request a copy of your data</li>
      <li>Withdraw consent for data processing</li>
    </ul>

    <h3>7. Data Retention</h3>
    <p>
      We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.
    </p>

    <h3>8. Children's Privacy</h3>
    <p>
      Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.
    </p>

    <h3>9. Third-Party Links</h3>
    <p>
      Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
    </p>

    <h3>10. Changes to This Privacy Policy</h3>
    <p>
      We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
    </p>

    <h3>11. Contact Us</h3>
    <p>If you have questions about this Privacy Policy, please contact us:</p>
    <ul>
      <li><strong>Email:</strong>support@litstudio.in</li>
      <li><strong>Address:</strong> LitStudio, India</li>
    </ul>
  </Modal>

  {/* Cookie Policy Modal */}
  <Modal
    isOpen={showCookie}
    onClose={() => setShowCookie(false)}
    title="Cookie Policy"
  >
    <p><strong>Effective Date:</strong> November 22, 2025</p>
    <p><strong>Last Updated:</strong> November 22, 2025</p>

    <h3>1. What Are Cookies</h3>
    <p>
      Cookies are small text files stored on your device when you visit a website. They help the site remember information about your visit, such as your login session, so you don't have to re-enter it every time.
    </p>

    <h3>2. How We Use Cookies</h3>
    <p>
      LitStudio uses cookies for essential purposes only — primarily to keep you signed in and to remember your session while you browse or manage a booking. We do not currently use cookies for advertising, and we do not sell or share cookie data with third-party advertisers.
    </p>

    <h3>3. Types of Cookies We Use</h3>
    <ul>
      <li><strong>Strictly Necessary:</strong> Required for core functionality such as authentication and keeping you logged in. The site cannot function properly without these.</li>
      <li><strong>Preference Cookies:</strong> Remember choices you've made, such as your account type, so you don't have to set them again on each visit.</li>
    </ul>

    <h3>4. Managing Cookies</h3>
    <p>
      Most browsers let you view, manage, and delete cookies through their settings. Blocking strictly necessary cookies may prevent you from logging in or using core features of the platform.
    </p>

    <h3>5. Changes to This Policy</h3>
    <p>
      We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated "Last Updated" date.
    </p>

    <h3>6. Contact Us</h3>
    <p>If you have questions about this Cookie Policy, please contact us:</p>
    <ul>
      <li><strong>Email:</strong> support@litstudio.in</li>
      <li><strong>Address:</strong> LitStudio, India</li>
    </ul>
  </Modal>

  {/* Terms & Conditions Modal */}
  <Modal
  isOpen={showTerms}
  onClose={() => setShowTerms(false)}
  title="Terms & Conditions"
>
  <p><strong>Effective Date:</strong> November 22, 2025</p>
  <p><strong>Last Updated:</strong> November 22, 2025</p>

  <p>
    Welcome to LitStudio.in ("LitStudio", "we", "our", "us"). 
    LitStudio Technologies Private Limited operates this platform to connect Users with professional Photographers 
    for various types of shoots including weddings, events, personal portraits, food, fashion, and commercial photography.
  </p>
  <p>
    By using LitStudio, you ("User" or "Photographer") agree to comply with the following Terms & Conditions. 
    Please read them carefully before registering or making a booking.
  </p>

  <h3>1. Definitions</h3>
  <ul>
    <li><strong>Platform:</strong> The LitStudio website, mobile application, and associated services.</li>
    <li><strong>User/Client:</strong> Any individual or business using LitStudio to discover, compare, and book photographers.</li>
    <li><strong>Photographer:</strong> Any individual or business offering photography services through LitStudio.</li>
    <li><strong>Booking:</strong> A confirmed engagement between a User and a Photographer through LitStudio.</li>
    <li><strong>Content:</strong> All photographs, videos, reviews, text, logos, graphics, and other materials uploaded to the platform.</li>
    <li><strong>Intellectual Property (IP):</strong> Creative work such as photos, videos, and portfolios owned by the respective creators.</li>
  </ul>

  <h3>2. Acceptance of Terms</h3>
  <ul>
    <li>By registering or using LitStudio, you agree to these Terms, our Privacy Policy, and any future updates.</li>
    <li>You must be at least 18 years old and legally capable of entering into binding contracts.</li>
    <li>If you disagree with any part of these Terms, you must not use the platform.</li>
  </ul>

  <h3>3. Nature of Service</h3>
  <p><strong>LitStudio is a facilitator, not the service provider.</strong></p>
  <ul>
    <li>We provide a curated digital marketplace that helps Users connect with verified Photographers.</li>
    <li>All photography services are independently provided by photographers; LitStudio does not control the creative process or guarantee results.</li>
  </ul>

  <h3>4. User Terms</h3>
  
  <h4>4.1 Registration and Account</h4>
  <ul>
    <li>Users must create an account with valid contact details.</li>
    <li>Users are responsible for maintaining confidentiality of login credentials.</li>
    <li>Any suspicious activity must be immediately reported to <a href="mailto:support@litstudio.in">support@litstudio.in</a>.</li>
  </ul>

  <h4>4.2 Booking Process</h4>
  <ul>
    <li>Users can browse, select, and book photographers through the platform.</li>
    <li>Bookings are confirmed only upon successful payment through LitStudio's payment gateway.</li>
    <li>Users must provide accurate event details (date, location, duration, type, and preferences).</li>
  </ul>

  <h4>4.3 Payments and Fees</h4>
  <ul>
    <li>All payments are processed securely through LitStudio.</li>
    <li>A 1% convenience fee may apply to each booking.</li>
    <li>LitStudio holds the payment in escrow until the shoot is completed.</li>
    <li>Direct payments or offline transactions outside the platform are strictly prohibited.</li>
  </ul>

  <h4>4.4 Cancellations and Refunds</h4>
  <p><strong>Cancellation by User:</strong></p>
  <ul>
    <li>More than 7 days before the event → 80% refund</li>
    <li>Within 7 days → 50% refund</li>
    <li>Within 48 hours → No refund</li>
  </ul>
  <p><strong>Cancellation by Photographer:</strong></p>
  <ul>
    <li>Full 100% refund or replacement photographer will be provided.</li>
    <li>Refunds are processed within 7–10 business days.</li>
  </ul>

  <h4>4.5 User Conduct</h4>
  <ul>
    <li>Users must treat photographers with respect and professionalism.</li>
    <li>Harassment, abuse, or inappropriate behavior will lead to suspension or permanent ban.</li>
    <li>Users must not request or encourage photographers to bypass LitStudio for future bookings.</li>
  </ul>

  <h3>5. Photographer Terms</h3>
  
  <h4>5.1 Eligibility and Verification</h4>
  <ul>
    <li>Photographers must provide valid government-issued ID and proof of original portfolio work.</li>
    <li>All portfolios must feature the photographer's own authentic work — not copied, downloaded, or re-edited content from others.</li>
  </ul>

  <h4>5.2 Prohibition on Copying or Plagiarism</h4>
  <p>Photographers are <strong>strictly prohibited</strong> from:</p>
  <ul>
    <li>Uploading or claiming credit for others' photos or videos.</li>
    <li>Downloading, editing, or reposting work that belongs to another photographer.</li>
    <li>Using AI-generated or stock images without disclosure.</li>
  </ul>
  <p>If a photographer is found using copied or stolen work:</p>
  <ul>
    <li>The account will be permanently suspended.</li>
    <li>Payments may be withheld.</li>
    <li>Legal action may be initiated under the Copyright Act, 1957 (India).</li>
  </ul>

  <h4>5.3 Listings and Pricing</h4>
  <ul>
    <li>Photographers must accurately list services, packages, and sample work.</li>
    <li>Prices displayed must include all taxes and service charges.</li>
    <li>Once a booking is confirmed, the photographer must honor the agreed rate.</li>
  </ul>

  <h4>5.4 Membership and Commission</h4>
  <ul>
    <li>Photographers may be required to pay a monthly membership fee (₹70–₹100) to stay listed.</li>
    <li>LitStudio will deduct a 10% commission on each completed booking.</li>
  </ul>

  <h4>5.5 Delivery Commitments</h4>
  <ul>
    <li>Deliverables (edited photos/videos) must be submitted within the timeline agreed with the User.</li>
    <li>Delays beyond 7 days of the committed delivery date without valid cause may result in penalties or payment withholding.</li>
  </ul>

  <h4>5.6 Conduct and Professionalism</h4>
  <ul>
    <li>Photographers must maintain respectful behavior during shoots.</li>
    <li>Any misconduct (harassment, unprofessionalism, negligence) may result in immediate delisting.</li>
    <li>Communication with clients must remain through the LitStudio platform until the booking is confirmed.</li>
  </ul>

  <h3>6. Intellectual Property (IP) Rights</h3>
  
  <h4>6.1 Ownership</h4>
  <ul>
    <li>Photographers retain full ownership of their creative work.</li>
    <li>By uploading content, photographers grant LitStudio a non-exclusive, royalty-free license to use such content for marketing, promotional, and platform purposes.</li>
  </ul>

  <h4>6.2 Content Integrity</h4>
  <p>Users and photographers must not:</p>
  <ul>
    <li>Copy, reuse, or distribute others' photos/videos.</li>
    <li>Edit, watermark, or modify any portfolio images without permission.</li>
    <li>Claim ownership or remove author credits.</li>
  </ul>

  <h4>6.3 Copyright Violations</h4>
  <ul>
    <li>LitStudio maintains a zero-tolerance policy for plagiarism or IP theft.</li>
    <li>If reported, the accused photographer's account will be suspended immediately pending investigation.</li>
    <li>Repeat offenders will face permanent bans and legal proceedings.</li>
  </ul>

  <h3>7. Ratings, Reviews, and Feedback</h3>
  <ul>
    <li>After every booking, both User and Photographer may submit ratings and reviews.</li>
    <li>Reviews must be fair, honest, and based on personal experience.</li>
    <li>LitStudio may remove fake, offensive, or misleading reviews.</li>
    <li>Consistently high ratings may increase a photographer's visibility and tier level (Normal, Pro, Premium).</li>
  </ul>

  <h3>8. Dispute Resolution</h3>
  <ul>
    <li>Both parties should first attempt to resolve disputes amicably.</li>
    <li>If unresolved, LitStudio may mediate using booking details, chat history, and proof of delivery.</li>
    <li>LitStudio's mediation decision is final and binding for payment-related issues.</li>
  </ul>

  <h3>9. Prohibited Activities</h3>
  <p>Users or Photographers must not:</p>
  <ul>
    <li>Conduct transactions outside the LitStudio platform.</li>
    <li>Share false information, fake portfolios, or manipulated reviews.</li>
    <li>Upload offensive, obscene, or copyrighted material without permission.</li>
    <li>Attempt to hack, scrape, or misuse the platform.</li>
    <li>Engage in defamation, abuse, or discrimination against any user.</li>
  </ul>

  <h3>10. Liability and Disclaimer</h3>
  <ul>
    <li>LitStudio is not responsible for any disputes, damages, or losses arising between Users and Photographers.</li>
    <li>We do not guarantee the quality, quantity, or creative output of any service.</li>
    <li>LitStudio's total liability in any case shall not exceed the service fee earned by LitStudio from that booking.</li>
  </ul>

  <h3>11. Privacy</h3>
  <ul>
    <li>Personal data is collected, stored, and processed in accordance with our Privacy Policy.</li>
    <li>We do not sell or share personal data without consent, except when required by law.</li>
  </ul>

  <h3>12. Termination</h3>
  <ul>
    <li>LitStudio reserves the right to suspend or terminate any account for violations of these Terms.</li>
    <li>Users and Photographers may request account deletion by contacting <a href="mailto:support@litstudio.in">support@litstudio.in</a>.</li>
  </ul>

  <h3>13. Amendments</h3>
  <ul>
    <li>LitStudio may modify these Terms at any time.</li>
    <li>Updated terms will be published on this page, and continued use implies acceptance.</li>
  </ul>

  <h3>14. Governing Law</h3>
  <ul>
    <li>These Terms are governed by the laws of India.</li>
    <li>Jurisdiction for all disputes shall be the courts of Mumbai, Maharashtra.</li>
  </ul>

  <h3>15. Contact Us</h3>
  <p>For any queries, support, or grievance redressal:</p>
  <ul>
    <li><strong>Email:</strong> <a href="mailto:support@litstudio.in">support@litstudio.in</a></li>
    <li><strong>Website:</strong> <a href="https://www.litstudio.in">www.litstudio.in</a></li>
  </ul>

  <p style={{ marginTop: '24px', padding: '16px', backgroundColor: '#f3f4f6', borderRadius: '8px', fontStyle: 'italic', color: '#6b7280' }}>
    By using LitStudio, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
  </p>
</Modal>
</footer>
    </div>
  );
};

export default LandingPage;
